import React, { useEffect, useState, useRef } from "react";

import {
  Layout,
  Card,
  Button,
  Table,
  Tag,
  Avatar,
  Rate,
  Timeline,
  Descriptions,
  Dropdown,
  Menu,
  Row,
  Col,
  Modal,
  Collapse,
  Select,
  Skeleton,
  Slider,
  Checkbox,
  Tooltip,
  Image,
  Carousel,
  Badge,
} from "antd";
import {
  PrinterOutlined,
  HeatMapOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import io from "socket.io-client";

import leftarrow from "../../../../assets/img/orders/leftarrow.png";
import customer from "../../../../assets/img/orders/orderDetail/customer.png";
import mapIcon from "../../../../assets/img/orders/orderDetail/map.png";

import phone from "../../../../assets/img/orders/orderDetail/phone.png";
import message from "../../../../assets/img/orders/orderDetail/message.png";
import orderImg from "../../../../assets/img/orders/orderDetail/order.png";
import priceImg from "../../../../assets/img/orders/orderDetail/price.png";
import user from "../../../../assets/img/orders/orderDetail/user.png";
import whatsappStatus from "../../../../assets/img/orders/orderDetail/whatsappStatus.png";
import minusIcon from "../../../../assets/img/orders/minusIcon.png";
import plusIcon from "../../../../assets/img/orders/plusIcon.png";
import printImg from "../../../../assets/img/orders/orderDetail/print.png";
import QR from "../../../../assets/img/orders/orderDetail/QR.png";
import statuscustomer from "../../../../assets/img/orders/orderDetail/statuscustomer.png";
import storeStatus from "../../../../assets/img/orders/orderDetail/storeStatus.png";
import allStore from "../../../../assets/img/orders/orderDetail/allStore.png";
import prints from "../../../../assets/img/orders/orderDetail/prints.png";

import duration from "../../../../assets/img/orders/orderDetail/duration.png";
import distance from "../../../../assets/img/orders/orderDetail/distance.png";
import vehicle from "../../../../assets/img/orders/orderDetail/vehicle.png";
import like from "../../../../assets/img/orders/orderDetail/like.png";
import fallBackImage from "../../../../assets/img/orders/orderDetail/fallbackimage.png";
import cameraIcon from "../../../../assets/img/orders/orderDetail/cameraIcon.png";
import uploadCameraImage from "../../../../assets/img/orders/orderDetail/uploadIcon.png";
import summary from "../../../../assets/img/orders/orderDetail/like.png";
import { styles } from "components/ImageCropper/styles";

import pickAdd from "../../../../assets/img/orders/orderDetail/pickAdd.png";
import deliveryAdd from "../../../../assets/img/orders/orderDetail/deliveryAdd.png";
import editCollection from "../../../../assets/img/orders/editcollection.png";
import collectionDate from "../../../../assets/img/orders/collectionDate.png";
import deliverytime from "../../../../assets/img/orders/deliverytime.png";
import editdeleivery from "../../../../assets/img/orders/editdeleivery.png";
import jsPDF from "jspdf";

import moment from "moment";
import { API_GET_ORDER } from "api/order-management";
import { useNavigate, useParams } from "react-router-dom";
import { API_ORDER_STATUS } from "api/order-management";
import { API_LIST_LAUNDRY_MEN } from "api/laundry-management";
import { API_ASSIGN_ORDER_TO_DRIVER } from "api/laundry-management";
import { toast } from "react-toastify";
import Printinvoice from "./Printinvoice";

import { CONSTANTS } from "config/constant";
import Cropper from "react-easy-crop";
import ImageCropper from "components/ImageCropper/ImageCropper";
import { API_REPAIR_ITEM } from "api/order-management";
import DriverMap from "components/Map/DriverMap";
import { API_NEARBY_DRIVER } from "api/order-management";
import userplace from "../../../../assets/img/orders/orderDetail/userplace.png";
import { API_LIST_STORE } from "api/store-managemnt";
import { Option } from "antd/es/mentions";
import LiveTrack from "components/Map/LiveTrack";
import { PiNotepad } from "react-icons/pi";
import { API_ASSIGN_PROVIDER } from "api/order-management";
import useMessage from "antd/es/message/useMessage";
import { useMessages } from "config/MessageProvider";
import { useTranslation } from "react-i18next";

const { Header, Content } = Layout;
const { Panel } = Collapse;

const ViewUpdated = () => {
  // const data = location.state && location.state.data;
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleItems, setIsModalVisibleItems] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [isModalVisibleDriver, setIsModalVisibleDriver] = useState(false);
  const [itemCounts, setItemCounts] = useState({});
  const [triggerUpload, setTriggerUpload] = useState(false);
  const [drivers, setDrivers] = useState();
  const [data, setData] = useState();
  const [isModalVisibleOrderNote, setIsModalVisibleOrderNote] = useState(false);
  const [orderNote, setOrderNote] = useState(false);
  const [itemNoteVisible, setItemNoteVisible] = useState(false);
  const [itemNote, setItemNote] = useState("");

  const [status, setStatus] = useState(data?.order_status);
  const [isModalVisibleStatus, setIsModalVisibleStatus] = useState(false);
  const [loadingStore, setLoadingStore] = useState(false);
  const [store, setStore] = useState("");
  const [dataStore, setDataStore] = useState([]);

  const [activeKeys, setActiveKeys] = useState([]);
  const [image, setImage] = useState(null);
  const [imageToUpload, setImageToUpload] = useState(null);
  const [imagesToSend, setImagesToSend] = useState([]);
  const [displayImage, setDisplayImage] = useState("");
  const [laundryId, setLaundryId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(
    data?.order_user_info?.phone_no
  );
  const [paginationStore, setPaginationStore] = useState({
    current: 1,
    pageSize: 10,
    totalPages: 1,
  });
  const [selectedDriverEmail, setSelectedDriverEmail] = useState(null);
  const {t}= useTranslation();
  const { handleorderStatus } = useMessages();
  const [radius, setRadius] = useState(1000);

  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const userDataString = localStorage.getItem("userData");
  const componentRef = useRef();
  const qrCodeRef = useRef();
  const handleQrPrint = useReactToPrint({ content: () => qrCodeRef.current });
  let { id } = useParams();
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const handleDriverSelect = (email) => {
    setSelectedDriverEmail(email);
  };
  const showModal = (record) => {
    console.log(record, "recordsdsd");
    setSelectedRow(record);
    setIsModalVisibleItems(true);
    console.log("record in row", record);
  };

  const handleCancel = () => {
    setIsModalVisibleItems(false);
    setSelectedRow(null);
  };

  const handleCollapseChange = (key) => {
    setActiveKeys(key);
  };

  const handleDownload = () => {
    if (data?.qrCode) {
      // Initialize jsPDF instance
      const doc = new jsPDF();
      // Add image to PDF
      doc.addImage(data.qrCode, "PNG", 10, 10, 50, 50); // Adjust positioning and size as needed
      // Save PDF
      doc.save("qrCode.pdf");
    }
  };

  const fetchDataOrder = async () => {
    setLoading(true);
    try {
      const newData = await API_GET_ORDER(id);
      console.log("provider", newData);
      setData(newData?.order);
      setStatus(newData?.order?.order_status);
      setOrderNote(newData?.order?.order_note);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const options = [
    "order_delivered_to_store_before_service",
    // "order_pickedup_by_driver_to_laundry",
    "order_delivered_to_laundry_before_service",
    "order_service_completed",
    // "order_pickedup_by_driver_after_service",
    "order_delivered_to_store_after_service",
    // "order_pickedup_by_driver_to_deliver_to_customer",
    "order_delivered_successfully",
  ];
  // const formattedOptions = options?.map((status) => ({
  //   value: status,
  //   label: status
  //     ?.replace(/_/g, " ")
  //     ?.replace(/\b\w/g, (char) => char.toUpperCase()),
  // }));
  const formattedOptions = options?.map((status) => {
    let label = status
      ?.replace(/_/g, " ")
      ?.replace(/\b\w/g, (char) => char.toUpperCase());

    if (status === "order_accepted") {
      label = "Order Accepted by Driver";
    }

    return {
      value: status,
      label: label,
    };
  });

  const orderStatusToggle = async (value) => {
    if (typeof handleorderStatus === "function") {
      handleorderStatus();
    } else {
      console.error("handleorderStatus is not a function");
    }
    if (value === "order_delivered_to_laundry_before_service") {
      setIsModalVisibleStatus(false);
      setStatus(value);
      StatusApiCall(value);
    } else if (value === "order_service_completed") {
      setStatus(value);
      StatusApiCall(value);
      setIsModalVisibleStatus(false);
    } else if (value === "order_delivered_successfully") {
      setStatus(value);
      StatusApiCall(value);
      setIsModalVisibleStatus(false);
    } else if (
      value === "order_delivered_to_store_before_service" &&
      process.env.REACT_APP_APPLICATION_NAME === "provider"
    ) {
      setStatus(value);
      StatusApiCall(value);
      setIsModalVisibleStatus(false);
    } else if (
      value === "order_delivered_to_store_after_service" &&
      process.env.REACT_APP_APPLICATION_NAME === "provider"
    ) {
      setStatus(value);
      StatusApiCall(value);
      setIsModalVisibleStatus(false);
    } else {
      setStatus(value);
      setIsModalVisibleStatus(true);
    }
    // if(value){
    //   setIsModalVisibleStatus(true);
    //   const res = await StatusApiCall(value)
    //   console.log(res,'responsadfasdf')
    // }
  };
  const StatusApiCall = async (value) => {
    try {
      let payload = {
        order_id: data?._id,
        order_status: value,
      };
      switch (value) {
        case "order_delivered_to_store_before_service":
          payload.provider_id = store;
          break;
        case "order_delivered_to_laundry_before_service":
        case "order_service_completed":
          payload.laundry_id = "66c70ccc43e12384d42979a8";
          break;
        case "order_delivered_to_store_after_service":
          payload.provider_id = store;
          break;
        case "order_delivered_successfully":
          // No additional fields required for this status
          break;
        default:
          throw new Error("Invalid status");
      }
      const userData = await API_ORDER_STATUS(payload);
      toast.success(userData?.message);
      setIsModalVisibleStatus(false);
      fetchDataOrder();
      console.log("api call... try", value);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error("error", error);
    } finally {
      // setSubmitting(false);
    }
    // try {
    //   const payload = {
    //     order_id: data?._id,
    //     order_status: status,
    //     provider_id: value,
    //     laundry_id: "67a5e75fb33ac6fba619cc6a",
    //   };
    //   const userData = await API_ORDER_STATUS(payload);
    //   toast.success(userData?.message);
    // } catch (error) {
    //   toast.error("Server Error");

    //   console.error("error", error);
    //   // toast.error(error?.response?.data?.message);
    // } finally {
    //   // setSubmitting(false);
    // }
  };

  const fetchData = async () => {
    try {
      // setLoading(true);
      const payload = {
        order_id: id,
        search_radius: radius,
      };
      // const newData = await API_LIST_LAUNDRY_MEN(payload);
      const newData = await API_NEARBY_DRIVER(payload);

      console.log("provider laundry===", newData);
      setDrivers(newData?.laundry_men);
      // setLoading(false);
      setPagination({ ...pagination, total: newData.totalLaundryMen }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const handleCountMinus = (item) => {
    setItemCounts((prevItemCounts) => {
      const newCount = (prevItemCounts[item._id] || 1) - 1;
      if (newCount < 1) return prevItemCounts; // Prevent count from going below 1
      return {
        ...prevItemCounts,
        [item._id]: newCount,
      };
    });
  };

  const handleCountPlus = (item) => {
    setItemCounts((prevItemCounts) => ({
      ...prevItemCounts,
      [item._id]: (prevItemCounts[item?._id] || 1) + 1,
    }));
  };

  const handleAssignDriver = async (driver) => {
    try {
      const payload = {
        laundry_man_id: driver?._id,
        order_id: data?._id,
      };
      const response = await API_ASSIGN_ORDER_TO_DRIVER(payload);
      console.log("response", response);
      if (response) {
        setIsModalVisibleDriver(false);
        toast.success(response?.message);
      }
      fetchDataOrder();
    } catch (error) {
      console.error("Error assigning order to driver:", error);
    }
  };

  // const handleAssignDriver = async (driver) => {
  //   try {
  //     let payload = {};

  //     // Check the status and create the appropriate payload
  //     if (
  //       status === "order_delivered_to_store_before_service" ||
  //       status === "order_delivered_to_store_after_service"
  //     ) {
  //       payload = {
  //         provider_id: store,
  //         provider_type: status,
  //         laundry_man_id: driver?._id,
  //       };

  //       // Call API_ASSIGN_PROVIDER with the modified payload
  //       const response = await API_ASSIGN_PROVIDER(payload);
  //       console.log("response", response);
  //       if (response) {
  //         setIsModalVisibleDriver(false);
  //         toast.success(response?.message);
  //       }
  //     } else {
  //       // Default payload for other statuses
  //       payload = {
  //         laundry_man_id: driver?._id,
  //         order_id: data?._id,
  //       };

  //       // Call API_ASSIGN_ORDER_TO_DRIVER with the default payload
  //       const response = await API_ASSIGN_ORDER_TO_DRIVER(payload);
  //       console.log("response", response);
  //       if (response) {
  //         setIsModalVisibleDriver(false);
  //         toast.success(response?.message);
  //       }
  //     }

  //     // Refresh the order data after assigning the driver
  //     fetchDataOrder();
  //   } catch (error) {
  //     console.error("Error assigning order to driver:", error);
  //   }
  // };

  // let orderSummary = data?.items
  const calculateTotalPrice = (item) => {
    console.log("item cal", item);
    const total = item?.item_info?.item_service?.reduce(
      (total, service) => total + Number(service?.price),
      0
    );
    const itemCount = itemCounts[item._id] || 1;
    return total * itemCount;
  };
  const columns = [
    { title: "Name", dataIndex: "first_name", key: "first_name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Contact", dataIndex: "phone_no", key: "phone_no" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleAssignDriver(record)}>
          Assign
        </Button>
      ),
    },
  ];
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    fetchDataOrder();
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, radius]);

  const menu = (
    <Menu>
      <Menu.Item key="1">In Progress</Menu.Item>
      <Menu.Item key="2">Completed</Menu.Item>
      <Menu.Item key="3">Cancelled</Menu.Item>
    </Menu>
  );
  const uniqueServiceIds = [
    ...new Set(
      data?.items?.flatMap((item) =>
        item?.item_info?.item_service?.map((service) => service._id)
      )
    ),
  ];

  const laundryManInfo = data?.order_status_info;
  const lastLaundryManInfo = laundryManInfo
    ? laundryManInfo[laundryManInfo.length - 1]
    : null;

  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImageToUpload(file);
    console.log(file, "i am");
    const reader = new FileReader();
    reader.onloadend = () => {
      console.log(reader.result, "result");
      setImage(reader?.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
    setTriggerUpload(false);
  };

  const handleUploadImage = async (image) => {
    console.log(image, "image");
    const formData = new FormData();
    formData.append("images", image);
    try {
      const res = await API_REPAIR_ITEM(formData);
      console.log(res);
      setImageModal(false);

      if (res) {
        console.log(";wow", res?.file);
        res?.file?.forEach((element) => {
          setImagesToSend((prev) => [...prev, element]);
        });
        setImageModal(false);
        setImage(null);
        setImageToUpload(null);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (triggerUpload) {
      handleImageClick();
    }
  }, [triggerUpload]);
  console.log(data, "imagessstosend");
  const handleConfirm = () => {
    const data = {
      item_id: "",
      repair: true,
      images: [],
    };
  };

  const convertTimestampsToFormattedDates = (timestamps) => {
    if (
      !timestamps ||
      typeof timestamps !== "object" ||
      !timestamps.from ||
      !timestamps.to
    ) {
      return "Invalid Timestamps";
    }

    const { from, to } = timestamps;
    const fromDate = moment.unix(from);
    const toDate = moment.unix(to);
    if (!fromDate.isValid() || !toDate.isValid()) {
      return "Invalid Date";
    }
    const formattedFrom = fromDate.format("h A ddd, MMM D, YYYY");
    const formattedTo = toDate.format("h A ddd, MMM D, YYYY");
    return `${formattedFrom} - ${formattedTo}`;
  };
  console.log("drivers ==>", drivers);

  const driversNew = drivers?.map((driver) => ({
    profile: driver?.profile_image[0]?.file_url
      ? CONSTANTS?.IMG_DIRECTORY + driver?.profile_image[0]?.file_url
      : userplace,
    name: `${driver?.first_name} ${driver?.last_name}`,
    email: driver?.email,
    contact: driver?.phone_no,
    latitude: driver?.geo?.coordinates[0],
    longitude: driver?.geo?.coordinates[1],
  }));

  function printImage() {
    const imgSrc = document.getElementById("imageToPrint").src;
    const originalContent = document.body.innerHTML;

    const printContent = `
      <html>
        <head>
          <title>Print Image</title>
          <style>
            body { display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; }
            img { max-width: 100%; max-height: 100%; }
          </style>
        </head>
        <body>
          <img src="${imgSrc}" onload="window.print(); window.onafterprint = () => { document.body.innerHTML = originalContent; }" />
        </body>
      </html>
    `;

    document.body.innerHTML = printContent;
  }
  const rowClassName = (record) => {
    return record.email == selectedDriverEmail ? "selected-rows-driver" : "";
  };
  const rowStyles = (record) => {
    return record.email === selectedDriverEmail
      ? { backgroundColor: "blue !important", color: "white" }
      : {};
  };
  const handleScrollStore = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (paginationStore.current < pagination.totalPages) {
        setPaginationStore((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };
  const fetchDataStore = async (page) => {
    try {
      setLoadingStore(true);
      const params = {
        page: page,
        limit: paginationStore.pageSize,
        // laundry: mainLaundry,
      };
      const newData = await API_LIST_STORE(params);
      setDataStore(newData?.providers);

      setPaginationStore((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.total_pages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingStore(false);
    }
  };

  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<---------------------------------Sockets --------------------------------->>>>>>>>>>>>>

  // useEffect(() => {
  //   const socket = io(CONSTANTS?.BACKEND_URL + `?userId=${AdminId}&role=admin`); // Replace with your backend URL

  //   socket.on("driverUpdate", (updatedDriver) => {
  //     // setDrivers((prevDrivers) =>
  //     //   prevDrivers?.map((driver) =>
  //     //     driver.email === updatedDriver.email ? updatedDriver : driver
  //     //   )
  //     // );
  //   });

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);
  useEffect(() => {
    fetchDataStore(pagination.current);
  }, [paginationStore.current]);
  console.log("drivesssss", data);
  console.log("dasdasd", selectedImages);

  return (
    <Layout>
      <Header className="flex  items-center justify-between bg-white p-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center cursor-pointer">
            <img src={leftarrow} onClick={() => navigate(-1)} />
            <h1 className="font-poppins text-[22px] font-medium text-[#1E293B]">
              {t("Order View")}
            </h1>
          </div>

          <span className="font-poppins text-[21px] font-medium text-[#3860A4]">
            {t("Order ID:")} {data?.order_id}
          </span>
        </div>

        <div className="flex items-center">
          {/* order_placed, order_service_completed */}

          {/* status == "order_pickedup_by_driver" ||
          status == "order_pickedup_by_driver_to_laundry" ||
          status == "order_pickedup_by_driver_after_service" ||
          status == "order_pickedup_by_driver_to_deliver_to_customer" || status == 'order_delivered_to_laundry_before_service' */}
          {status == "order_placed" ||
          status == "order_service_completed" ||
          status == "order_delivered_to_store_before_service" ||
          status == "order_delivered_to_store_after_service" ? (
            <Button
              className="btn-gradient  ml-2 flex w-36 items-center justify-center p-4 text-[white]"
              icon={
                <img
                  src={mapIcon}
                  style={{ height: "1rem", width: "1rem" }}
                  alt=""
                />
              }
              onClick={() => setIsModalVisibleDriver(true)}
            >
              {t("Assign Driver")}
            </Button>
          ) : (
            ""
          )}
          <Button
            className="btn-gradient  ml-2 mr-2 flex w-20 items-center justify-center p-5 pb-[12px] pt-[13px] text-[white]"
            icon={<PrinterOutlined />}
            onClick={() => {
              // setSelectedOrder(record);
              // console.log("record", record);
              setTimeout(() => {
                handlePrint();
              }, 100);
            }}
          >
            {t("Print")}
          </Button>

          {/* <Dropdown overlay={menu}> */}
          {/* <Button
              className="font-poppins font-medium"
              style={{ border: "none", color: "#9496AE" }}
            >
              Order Status:&nbsp; &nbsp;
              <Tag color="green">{data?.order?.status}</Tag>
            </Button> */}
          <div className="statuss flex items-center gap-2">
            <p>{t("order Status")}</p>
            <Select
              className="order-status bg-[#EFF2F8]"
              onChange={(value) => {
                orderStatusToggle(value);
              }}
              value={status}
              style={{ width: "27rem", background: "#EFF2F8" }}
              options={formattedOptions}
            />
          </div>
          <div
            className="ml-3 cursor-pointer"
            onClick={() => setIsModalVisibleDriver(true)}
          ></div>
          {/* </Dropdown> */}
        </div>
      </Header>
      <Content className="bg-white p-6  ">
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8}>
            {loading ? (
              <>
                <Skeleton active />
              </>
            ) : (
              <Card style={{ border: "none" }}>
                <div className="flex justify-between">
                  {" "}
                  <p className="mb-4 font-semibold text-[#8B8B8B]">
                    {t("Cusomer Details")}
                  </p>
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={10}>
                    <div>
                      <div className="mb-3 flex items-center gap-2">
                        <img
                          src={
                            data?.order_user_info?.profile_image?.[0]?.file_url
                              ? CONSTANTS?.IMG_DIRECTORY +
                                data?.order_user_info?.profile_image?.[0]
                                  ?.file_url
                              : customer
                          }
                          style={{ maxWidth: "2.5rem", maxHeight: "2rem" }}
                        />

                        <div>
                          <p className="font-poppins font-normal text-[#9496AE]">
                            {t("Customer")}
                          </p>
                          <p className="font-medium text-[#3860A4]">
                            {data?.order_user_info?.first_name +
                              " " +
                              data?.order_user_info?.last_name}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2">
                          <img src={orderImg} />
                          <div>
                            <p className="font-poppins font-normal text-[#9496AE]">
                              {t("Order")}
                            </p>
                            <p className="font-medium text-[#3860A4]">
                              {t("items")} ({data?.invoice_details?.total_items}){" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col span={14}>
                    <div className="flex items-start justify-end gap-12">
                      <div>
                        <div className="mb-3 flex justify-end gap-4">
                          <img
                            src={phone}
                            onClick={() => {
                              setPhoneNumber(data?.order_user_info?.phone_no);
                              setIsModalVisible(true);
                            }}
                          />
                          <img
                            src={message}
                            onClick={() =>
                              window.open(
                                `https://wa.me/${data?.order_user_info?.phone_no}`,
                                "_blank"
                              )
                            }
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <img src={priceImg} />
                          <div>
                            <div className="flex justify-between">
                              <p className="font-poppins font-normal text-[#9496AE]">
                                {t("Price")}
                              </p>
                              {/* <p className="font-poppins font-normal text-[#9496AE]">
                              Paid
                            </p> */}
                            </div>
                            <p className="font-medium text-[#3860A4]">
                              {Number(
                                data?.invoice_details?.total_amount
                              ).toFixed(2)}{" "}
                              {t("SAR")}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="mt-2">
                        <div className="hidden">
                          <div
                            ref={qrCodeRef}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100vh",
                              width: "100%",
                              pageBreakBefore: "always",
                            }}
                          >
                            <img
                              src={data?.qrCode}
                              className="h-56 w-56"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                              }}
                              id="imageToPrint"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="flex h-full w-full flex-col items-center justify-center align-middle">
                          <img
                            src={data?.qrCode}
                            className="h-24 w-24"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                            }}
                            id="imageToPrint"
                            alt=""
                          />
                        </div>
                        <a
                          // href={data?.qrCode}
                          // download="qrCode.png"
                          // onClick={printImage}
                          onClick={handleQrPrint}
                          className="mt-2 flex justify-center"
                        >
                          <img src={prints} />
                        </a>
                      </div>
                    </div>
                    <Modal
                      title="User Phone Number"
                      visible={isModalVisible}
                      onCancel={() => {
                        setIsModalVisible(false);
                      }}
                      footer={null}
                    >
                      <p>{phoneNumber}</p>
                    </Modal>
                  </Col>
                </Row>
                <div className="mt-8">
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <div
                        className="relative h-auto cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-center text-[12px]"
                        style={{
                          border: "1px solid #CEAF89",
                          // paddingBottom: "8px",
                          // paddingTop: "8px",
                        }}
                      >
                        <div className="absolute left-[6px] top-[-6px] rounded-[3.13px] bg-[#FAF7F3] px-1 text-[9px] text-[#F4B718]">
                          {/* <img src={editCollection} /> */}
                          {t("Collection Time & Date")}
                        </div>
                        <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                          <img src={collectionDate} className="h-4" />
                        </div>
                        <p className="text-center">
                          {t("Collection Time :")}{" "}
                          {data?.order_pickup_time
                            ? convertTimestampsToFormattedDates(
                                data?.order_pickup_time
                              )
                            : moment(data?.order_pickup_time?.from).format(
                                "h A ddd, MMM D, YYYY"
                              )}
                        </p>
                        {/* {moment(data?.order_pickup_time?.from).format(
                          "h A ddd, MMM D, YYYY"
                        )} */}
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="relative h-auto cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px] text-center text-[12px]"
                        style={{
                          border: "1px solid #1CAB43",
                          // paddingBottom: "8px",
                          // paddingTop: "8px",
                        }}
                      >
                        <div className="absolute left-[6px] top-[-6px]">
                          <img src={deliverytime} />
                        </div>
                        <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                          <img src={editdeleivery} className="h-4" />
                        </div>
                        {/* 9Am -11Am Tue, 2024 */}
                        <p className="text-center">
                          {t("Delivery Time :")}{" "}
                          {convertTimestampsToFormattedDates(
                            data?.order_delivery_time
                          )}
                          {/* {moment(data?.order_delivery_time?.to).format(
                          "h A ddd, MMM D, YYYY"
                        )} */}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            )}
            <hr />

            <div className="Time Logs History current-status">
              {loading ? (
                <Skeleton active />
              ) : (
                <Card className="time-logs" style={{ border: "none" }}>
                  <Collapse
                    style={{ border: "none" }}
                    expandIconPosition="right" // Set the expand icon position to right
                    className="custom-collapse" // Add a custom class for further styling
                  >
                    <Panel
                      header={t("Time Logs History")}
                      key="1"
                      style={{ border: "none" }}
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          <div className="flex flex-col gap-5">
                            {data?.order_pickup_time?.history?.map(
                              (element, idx) => {
                                return (
                                  <div
                                    key={idx}
                                    className="relative h-[3rem] cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-[12px]"
                                    style={{ border: "1px solid #CEAF89" }}
                                  >
                                    <div className="absolute left-[6px] top-[-6px]">
                                      <img
                                        src={editCollection}
                                        alt="Edit Collection"
                                      />
                                    </div>
                                    <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                                      <img
                                        src={collectionDate}
                                        className="h-4"
                                        alt="Collection Date"
                                      />
                                    </div>
                                    <p className="text-center">
                                      {t("Collection Time :")}{" "}
                                      {convertTimestampsToFormattedDates(
                                        element
                                      )}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="flex flex-col gap-5">
                            {data?.order_delivery_time?.history?.map(
                              (element, idx) => {
                                return (
                                  <div
                                    key={idx}
                                    className="relative h-[3rem] cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px]  text-[12px]"
                                    style={{
                                      border: "1px solid #1CAB43",
                                    }}
                                  >
                                    <div className="absolute left-[6px] top-[-6px]">
                                      <img
                                        src={deliverytime}
                                        alt="Delivery Time"
                                      />
                                    </div>
                                    <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                                      <img
                                        src={editdeleivery}
                                        className="h-4"
                                        alt="Edit Delivery"
                                      />
                                    </div>
                                    <p className="text-center">
                                      {t("Delivery Time :")}{" "}
                                      {convertTimestampsToFormattedDates(
                                        element
                                      )}
                                    </p>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Panel>
                  </Collapse>
                </Card>
              )}
            </div>
            <hr />

            <div className="Time Logs History current-status Addresses">
              {loading ? (
                <Skeleton active />
              ) : (
                <Card className="time-logs" style={{ border: "none" }}>
                  <Collapse
                    style={{ border: "none" }}
                    expandIconPosition="right" // Set the expand icon position to right
                    className="custom-collapse" // Add a custom class for further styling
                  >
                    <Panel header={t("Address")} key="1" style={{ border: "none" }}>
                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          {/* <div
                            className="relative h-[3rem] cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-[12px]"
                            style={{
                              border: "1px solid #CEAF89",
                            }}
                          >
                            <div className="absolute left-[6px] top-[-6px]">
                              <img src={editCollection} alt="Edit Collection" />
                            </div>
                            <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                              <img
                                src={collectionDate}
                                className="h-4"
                                alt="Collection Date"
                              />
                            </div>
                            <p className="text-center">
                              Collection Time :{" "}
                              {moment().format("h A ddd, MMM D, YYYY")}
                            </p>
                          </div> */}
                          <div>
                            <p> {t("Pickup Address")}</p>

                            <Tag color="yellow">
                              {/* {data?.order_pickup_address?.location} */}
                              <Tooltip
                                title={data?.order_pickup_address?.location}
                              >
                                {data?.order_pickup_address?.location
                                  ? data?.order_pickup_address?.location
                                      ?.length > 20
                                    ? `${data?.order_pickup_address?.location?.substring(
                                        0,
                                        20
                                      )}...`
                                    : data?.order_pickup_address?.location
                                  : "--"}
                              </Tooltip>
                            </Tag>
                          </div>
                        </Col>
                        <Col span={12}>
                          {/* <div
                            className="relative h-[3rem] cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px]  text-[12px]"
                            style={{
                              border: "1px solid #1CAB43",
                            }}
                          >
                            <div className="absolute left-[6px] top-[-6px]">
                              <img src={deliverytime} alt="Delivery Time" />
                            </div>
                            <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                              <img
                                src={editdeleivery}
                                className="h-4"
                                alt="Edit Delivery"
                              />
                            </div>
                            <p className="text-center">
                              Delivery Time :{" "}
                              {moment().format("h A ddd, MMM D, YYYY")}
                            </p>
                          </div> */}
                          {console.log(data, "aifadfsadfasdhlj")}
                          <div>
                            <p> {t("Delivery Addresses")} </p>
                            <Tag color="green">
                              {/* {data?.order_delivery_address?.location} */}
                              <Tooltip
                                title={data?.order_delivery_address?.location}
                              >
                                {data?.order_delivery_address?.location
                                  ? data?.order_delivery_address?.location
                                      ?.length > 20
                                    ? `${data?.order_delivery_address?.location?.substring(
                                        0,
                                        20
                                      )}...`
                                    : data?.order_delivery_address?.location
                                  : "--"}
                              </Tooltip>
                            </Tag>
                          </div>
                        </Col>
                        <Col span={12}>
                          {/* <div
                            className="relative h-[3rem] cursor-pointer rounded-lg bg-[#ceaf8917] px-[13px] py-[10px]  text-[12px]"
                            style={{
                              border: "1px solid #CEAF89",
                            }}
                          >
                            <div className="absolute left-[6px] top-[-6px]">
                              <img src={editCollection} alt="Edit Collection" />
                            </div>
                            <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                              <img
                                src={collectionDate}
                                className="h-4"
                                alt="Collection Date"
                              />
                            </div>
                            <p className="text-center">
                              Collection Time :{" "}
                              {moment().format("h A ddd, MMM D, YYYY")}
                            </p>
                          </div> */}
                        </Col>
                        {/* <Col span={12}>
                          <div
                            className="relative h-[3rem] cursor-pointer rounded-lg bg-[#1cab4324] px-[13px] py-[10px] text-[12px]"
                            style={{
                              border: "1px solid #1CAB43",
                            }}
                          >
                            <div className="absolute left-[6px] top-[-6px]">
                              <img src={deliverytime} alt="Delivery Time" />
                            </div>
                            <div className="absolute left-[6px] right-0 top-0 flex justify-end">
                              <img
                                src={editdeleivery}
                                className="h-4"
                                alt="Edit Delivery"
                              />
                            </div>
                            <p className="text-center">
                              {" "}
                              Delivery Time :{" "}
                              {moment().format("h A ddd, MMM D, YYYY")}
                            </p>
                          </div>
                        </Col> */}
                      </Row>
                    </Panel>
                  </Collapse>
                </Card>
              )}
            </div>
            <hr />

            <div className="Time Logs History current-status Storessssss">
              {loading ? (
                <Skeleton active />
              ) : (
                <Card className={t("time-logs")} style={{ border: "none" }}>
                  <Collapse
                    style={{ border: "none" }}
                    expandIconPosition="right" // Set the expand icon position to right
                    className="custom-collapse" // Add a custom class for further styling
                  >
                    <Panel header={t("Stores")} key="1" style={{ border: "none" }}>
                      <Row gutter={[16, 16]}>
                        <Col span={24}>
                          <div className="text-center text-[16px] font-medium">
                            {t("Order Before Service")}
                          </div>
                          <div className="mt-2 flex gap-2">
                            <p className="font-medium">{t("Store Name")}</p>
                            <p>
                              {
                                data?.order_provider_before_service_info
                                  ?.store_name
                              }
                            </p>
                          </div>
                          <div className="mt-2 flex gap-2">
                            <p className="font-medium">{t("Store Email")}</p>
                            <p>
                              {data?.order_provider_before_service_info?.email}
                            </p>
                          </div>
                          <div className="mt-2 flex gap-2">
                            <p className="font-medium">{t("Store Phone No")}</p>
                            <p>
                              {
                                data?.order_provider_before_service_info
                                  ?.phone_no
                              }
                            </p>
                          </div>
                        </Col>
                        <hr />
                        {data?.order_provider_after_service_info && (
                          <Col span={24}>
                            <div className="text-center text-[16px] font-medium">
                              {" "}
                              {t("Order After Service")}
                            </div>
                            <div className="flex gap-2">
                              <p className="font-medium">{t("Store Name")}</p>
                              <p>
                                {
                                  data?.order_provider_after_service_info
                                    ?.store_name
                                }
                              </p>
                            </div>
                            <div className="mt-2 flex gap-2">
                              <p className="font-medium">{t("Store Email")}</p>
                              <p>
                                {data?.order_provider_after_service_info?.email}
                              </p>
                            </div>
                            <div className="mt-2 flex gap-2">
                              <p className="font-medium">{t("Store Phone No")}</p>
                              <p>
                                {
                                  data?.order_provider_after_service_info
                                    ?.phone_no
                                }
                              </p>
                            </div>
                          </Col>
                        )}
                        <Col span={12}></Col>
                      </Row>
                    </Panel>
                  </Collapse>
                </Card>
              )}
            </div>
            <hr />
            <div className=" current-status  Time Logs History ">
              {loading ? (
                <Skeleton active />
              ) : (
                <Card
                  className=" current-status time-logs curssss"
                  style={{ border: "none" }}
                >
                  <Collapse
                    defaultActiveKey={["1"]}
                    style={{ border: "none" }}
                    expandIconPosition="right"
                    className="custom-collapse"
                  >
                    <Panel
                      header={t("Assigned Driver")}
                      key="1"
                      style={{ border: "none" }}
                    >
                      {data?.order_assigned_info?.is_active ? (                                                           
                        <>
                          <Row gutter={[16, 16]}>
                            <Col span={12}>
                              <>
                                <p className="mb-4 font-poppins text-[#383838]">
                                  {t("Customer to Store")}
                                </p>

                                <div className="mb-3 flex items-center gap-2">
                                  <img
                                    src={
                                      data?.order_assigned_info
                                        ?.order_assigned_to_info
                                        ?.profile_image?.[0]?.file_url
                                        ? CONSTANTS?.IMG_DIRECTORY +
                                          data?.order_assigned_info
                                            ?.order_assigned_to_info
                                            ?.profile_image?.[0]?.file_url
                                        : user
                                    }
                                    style={{
                                      height: "2rem",
                                      width: "2rem",
                                      borderRadius: "50%",
                                    }}
                                    alt=""
                                  />
                                  <div>
                                    <p className="font-poppins font-medium text-[#3860A4]">
                                      {(data?.order_assigned_info
                                        ?.order_assigned_to_info?.first_name
                                        ? data?.order_assigned_info
                                            ?.order_assigned_to_info?.first_name
                                        : "No Name of driver") +
                                        " " +
                                        (data?.order_assigned_info
                                          ?.order_assigned_to_info?.last_name
                                          ? data?.order_assigned_info
                                              ?.order_assigned_to_info
                                              ?.last_name
                                          : "")}
                                    </p>
                                    <p className="text-black font-poppins font-medium">
                                      {
                                        data?.order_assigned_info
                                          ?.order_assigned_to_info?.email
                                      }
                                    </p>
                                    {data?.pickup_laundry_man_info && (
                                      <p className="font-poppins text-[12px] font-normal text-[#9496AE]">
                                        {t("Order no:")}{" "}
                                        <span className="text-[12px] font-medium text-[#9496AE]">
                                          {data?.order_id}
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </>
                            </Col>
                            <Col
                              span={12}
                              className="flex flex-col items-end justify-end"
                            >
                              <img
                                src={allStore}
                                className="mb-4 w-[4rem]"
                                alt=""
                              />

                              <div className="flex space-x-4">
                                <img
                                  src={phone}
                                  onClick={() => {
                                    setPhoneNumber(
                                      data?.order_assigned_info
                                        ?.order_assigned_to_info?.phone_no
                                    );
                                    setIsModalVisible(true);
                                  }}
                                  alt=""
                                />
                                <img
                                  alt=""
                                  src={whatsappStatus}
                                  style={{ height: "2.5rem" }}
                                  onClick={() =>
                                    window.open(
                                      `https://wa.me/${data?.order_assigned_info?.order_assigned_to_info?.phone_no}`,
                                      "_blank"
                                    )
                                  }
                                />
                              </div>
                            </Col>
                          </Row>

                          {/* <Row gutter={[16, 16]}>
                            <Col span={8}>
                              <div className="flex items-center gap-2">
                                <img
                                  src={duration}
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <p className="font-poppins text-[11px] font-normal text-[#9496AE]">
                                    Duration
                                  </p>
                                  <p className="font-poppins text-[11px] font-medium text-[#3860A4]">
                                    {" "}
                                    {data?.currentStatus?.duration}
                                  </p>
                                </div>
                              </div>
                            </Col>

                            <Col span={8}>
                              <div className="flex items-center gap-2">
                                <img
                                  src={distance}
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <p className="font-poppins text-[11px] font-normal text-[#9496AE]">
                                    Distance
                                  </p>
                                  <p className="font-poppins text-[11px] font-medium text-[#3860A4]">
                                    {" "}
                                    {data?.currentStatus?.distance}
                                  </p>
                                </div>
                              </div>
                            </Col>

                            <Col span={8}>
                              <div className="flex items-center gap-2">
                                <img
                                  src={vehicle}
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <p className="font-poppins text-[11px] font-normal text-[#9496AE]">
                                    Vehicle
                                  </p>
                                  <p className="font-poppins text-[11px] font-medium text-[#3860A4]">
                                    {" "}
                                    {data?.currentStatus?.vehicle}
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </Row> */}
                        </>
                      ) : (
                        <p>{t("No driver Information")}</p>
                      )}
                    </Panel>
                  </Collapse>
                </Card>
              )}
            </div>

            {/* laundry box Details  */}

            {data?.order_type === "box" && (
              <div className=" current-status  Time Logs History ">
                {loading ? (
                  <Skeleton active />
                ) : (
                  <Card
                    className=" current-status time-logs curssss"
                    style={{ border: "none" }}
                  >
                    <Collapse
                      defaultActiveKey={["1"]}
                      style={{ border: "none" }}
                      expandIconPosition="right" // Set the expand icon position to right
                      className="custom-collapse" // Add a custom class for further styling
                    >
                      <Panel
                        header={t("Laundry Box Details")}
                        key="1"
                        style={{ border: "none" }}
                      >
                        {data?.laundry_box_order_detail ? (
                          <>
                            <Row gutter={[16, 16]}>
                              <Col span={24}>
                                <>
                                  {data?.laundry_box_order_detail
                                    ?.order_image?.[0]?.file_url && (
                                    <div className="mb-2">
                                      <div className="h-[4rem] w-[4rem] overflow-hidden rounded-[100%]">
                                        <Image
                                          src={
                                            data?.laundry_box_order_detail
                                              ?.order_image?.[0]?.file_url
                                              ? CONSTANTS?.IMG_DIRECTORY +
                                                data?.laundry_box_order_detail
                                                  ?.order_image?.[0]?.file_url
                                              : user
                                          }
                                          style={{
                                            height: "4rem",
                                            width: "4rem",
                                            borderRadius: "50%",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                  <div className="mb-3 flex items-center gap-2">
                                    <div>
                                      <p className="font-poppins font-medium ">
                                        {t("Name :")}{" "}
                                        {
                                          data?.laundry_box_order_detail
                                            ?.laundry_box_info?.name
                                        }
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 flex items-center gap-2">
                                    <div>
                                      <p className="font-poppins font-medium ">
                                        {t("Capacity :")}{" "}
                                        {
                                          data?.laundry_box_order_detail
                                            ?.laundry_box_info?.no_of_items
                                        }{" "}
                                        {t("Item")}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 flex items-center gap-2">
                                    <div>
                                      <p className="font-poppins font-medium ">
                                        {t("Appartment No :")}{" "}
                                        {
                                          data?.laundry_box_order_detail
                                            ?.apartment_no
                                        }
                                      </p>
                                    </div>
                                  </div>
                                </>
                              </Col>
                              {/* <Col
                                span={12}
                                className="flex flex-col items-end justify-end"
                              >
                                <img
                                  src={allStore}
                                  className="mb-4 w-[4rem]"
                                  alt=""
                                />

                                <div className="flex space-x-4">
                                  <img
                                    src={phone}
                                    onClick={() => {
                                      setPhoneNumber(
                                        data?.order_assigned_info
                                          ?.order_assigned_to_info?.phone_no
                                      );
                                      setIsModalVisible(true);
                                    }}
                                    alt=""
                                  />
                                  <img
                                    alt=""
                                    src={whatsappStatus}
                                    style={{ height: "2.5rem" }}
                                    onClick={() =>
                                      window.open(
                                        `https://wa.me/${data?.order_assigned_info?.order_assigned_to_info?.phone_no}`,
                                        "_blank"
                                      )
                                    }
                                  />
                                </div>
                              </Col> */}
                              {/* <Col span={8}>
                              <LiveTrack />
                            </Col> */}
                            </Row>
                          </>
                        ) : (
                          <p>{t("No driver Information")}</p>
                        )}
                      </Panel>
                    </Collapse>
                  </Card>
                )}
              </div>
            )}
            {/* laundry Box details */}

            {/* Current driver */}
            {/* <div className=" current-status  Time Logs History ">
              {loading ? (
                <Skeleton active />
              ) : (
                <Card
                  className=" current-status time-logs curssss"
                  style={{ border: "none" }}
                >
                  <Collapse
                    defaultActiveKey={["1"]}
                    style={{ border: "none" }}
                    expandIconPosition="right"
                    className="custom-collapse px-0"
                  >
                    <Panel
                      header="Current Driver"
                      key="1"
                      style={{ border: "none" }}
                    >
                      {data?.order_status_info?.length > 0 ? (
                        <>
                          <Row gutter={[16, 16]}>
                            <Col span={24}>
                              <div className="flex">
                                <div>
                                  <p className="mb-4 font-poppins text-[#383838]">
                                    Customer to Store
                                  </p>

                                  <div className="mb-3 flex items-center gap-2">
                                    <img
                                      src={
                                        data?.order_status_info[
                                          data?.order_status_info.length - 1
                                        ]?.laundry_man_info?.profile_image?.[0]
                                          ?.file_url
                                          ? CONSTANTS?.IMG_DIRECTORY +
                                            data?.order_status_info[
                                              data?.order_status_info.length - 1
                                            ]?.laundry_man_info
                                              ?.profile_image?.[0]?.file_url
                                          : user
                                      }
                                      style={{
                                        height: "2rem",
                                        width: "2rem",
                                        borderRadius: "50%",
                                      }}
                                      alt=""
                                    />
                                    <div>
                                      <p className="font-poppins font-medium text-[#3860A4]">
                                        {(data?.order_status_info[
                                          data?.order_status_info.length - 1
                                        ]?.laundry_man_info?.first_name ||
                                          "No Name of driver") +
                                          " " +
                                          (data?.order_status_info[
                                            data?.order_status_info.length - 1
                                          ]?.laundry_man_info?.last_name || "")}
                                      </p>
                                      <p className="text-black font-poppins font-medium">
                                        {
                                          data?.order_status_info[
                                            data?.order_status_info.length - 1
                                          ]?.laundry_man_info?.email
                                        }
                                      </p>
                                      <p className="text-black font-poppins font-medium">
                                        {
                                          data?.order_status_info[
                                            data?.order_status_info.length - 1
                                          ]?.laundry_man_info?.phone_no
                                        }
                                      </p>
                                      {data?.pickup_laundry_man_info && (
                                        <p className="font-poppins text-[12px] font-normal text-[#9496AE]">
                                          Order no:{" "}
                                          <span className="text-[12px] font-medium text-[#9496AE]">
                                            {data?.order_id}
                                          </span>
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <img
                                    src={allStore}
                                    className="mb-4 w-[4rem]"
                                    alt=""
                                  />

                                  <div className="flex space-x-4">
                                    <img
                                      src={phone}
                                      onClick={() => {
                                        setPhoneNumber(
                                          data?.order_status_info[
                                            data?.order_status_info.length - 1
                                          ]?.laundry_man_info?.phone_no
                                        );
                                        setIsModalVisible(true);
                                      }}
                                      alt=""
                                    />
                                    <img
                                      alt=""
                                      src={whatsappStatus}
                                      style={{ height: "2.5rem" }}
                                      onClick={() =>
                                        window.open(
                                          `https://wa.me/${
                                            data?.order_status_info[
                                              data?.order_status_info.length - 1
                                            ]?.laundry_man_info?.phone_no
                                          }`,
                                          "_blank"
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col span={24}>
                              <LiveTrack
                                location={
                                  data?.order_status_info[
                                    data?.order_status_info.length - 1
                                  ]
                                }
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <p>No driver Information</p>
                      )}
                    </Panel>
                  </Collapse>
                </Card>
              )}
            </div> */}
            {/* Current driver */}

            <div className=" Reviews Time Logs History current-status">
              {loading ? (
                <Skeleton active />
              ) : (
                <Card className=" Reviews time-logs" style={{ border: "none" }}>
                  <Collapse
                    defaultActiveKey={["1"]}
                    style={{ border: "none" }}
                    expandIconPosition="right"
                    className="custom-collapse"
                  >
                    <Panel header={t("Reviews")} key="1" style={{ border: "none" }}>
                      <Row gutter={[16, 16]}>
                        <Col span={6}>
                          <div className="flex items-center space-x-3">
                            <img src={like} />
                            {data?.order_review?.[0]?.application_review
                              ?.review ? (
                              <div>
                                <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                  {t("Application")}
                                </p>
                                <Rate
                                  disabled
                                  value={
                                    data?.order_review?.[0]?.application_review
                                      ?.review
                                  }
                                />
                              </div>
                            ) : (
                              <p className="font-poppins text-[9px] font-normal text-[#383838]">
                                {t("No Application Review")}
                              </p>
                            )}
                          </div>
                        </Col>

                        <Col span={6}>
                          <div className="flex items-center space-x-3">
                            <img src={like} />
                            {data?.order_review?.[0]?.pickup_driver_review
                              ?.review ? (
                              <div>
                                <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                  {t("Quality of service")}
                                </p>
                                <Rate
                                  disabled
                                  value={
                                    data?.order_review?.[0]?.service_review
                                      ?.review
                                  }
                                />
                              </div>
                            ) : (
                              <p className="font-poppins text-[9px] font-normal text-[#383838]">
                                {t("No Quality of service Review")}
                              </p>
                            )}
                          </div>
                        </Col>

                        <Col span={6}>
                          <div className="flex items-center space-x-3">
                            <img src={like} />
                            {data?.order_review?.[0]?.pickup_driver_review
                              ?.review ? (
                              <div>
                                <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                  {t("Pickup Driver")}
                                </p>
                                <Rate
                                  disabled
                                  value={
                                    data?.order_review?.[0]
                                      ?.pickup_driver_review?.review
                                  }
                                />
                              </div>
                            ) : (
                              <p className="font-poppins text-[9px] font-normal text-[#383838]">
                               {t("No pickup Driver Review")}{" "}
                              </p>
                            )}
                          </div>
                        </Col>

                        <Col span={6}>
                          <div className="flex items-center space-x-3">
                            <img src={like} />
                            {data?.order_review?.[0]?.delivery_driver_review
                              ?.review ? (
                              <div>
                                <p className="font-poppins text-[12px] font-normal text-[#383838]">
                                  {t("Delivery driver")}
                                </p>
                                <Rate
                                  disabled
                                  value={
                                    data?.order_review?.[0]
                                      ?.delivery_driver_review?.review
                                  }
                                />
                              </div>
                            ) : (
                              <p className="font-poppins text-[9px] font-normal text-[#383838]">
                                {t("No Delivery driver Review")}
                              </p>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Panel>
                  </Collapse>
                </Card>
              )}
            </div>
            <hr />
            {(data?.pickup_from_customer_info?.first_name ||
              data?.pickup_from_store_before_service_info?.first_name ||
              data?.pickup_from_store_after_service_info?.first_name) && (
              <div className="Drivers   current-status">
                <Card title={t("Drivers")} style={{ border: "none" }}>
                  <Row
                    gutter={[16, 16]}
                    style={{ display: "flex", gap: "10px" }}
                  >
                    {data?.pickup_from_customer_info?.first_name && (
                      <Col xs={24} lg={6}>
                        <p>
                          <p>{t("Customer to Store")}</p>
                          <img src={allStore} alt="" />
                          <div className="flex items-center justify-between ">
                          <Image className="mr-5" src={CONSTANTS?.IMG_DIRECTORY + data?.pickup_from_customer_info?.profile_image?.[0]?.file_url} alt="" style={{width:"2.5rem",height:"2.5rem",borderRadius:"50%",objectFit:"cover",marginRight:"2rem"}}    />

                            <p className="font-poppins text-[#46BCED] ml-3">
                              {/* John Doe */}
                              {data?.pickup_from_customer_info?.first_name +
                                " " +
                                data?.pickup_from_customer_info?.last_name}
                            </p>
                            <img
                              src={phone}
                              className="h-6"
                              onClick={() => {
                                setPhoneNumber(
                                  data?.pickup_from_customer_info?.phone_no
                                );
                                setIsModalVisible(true);
                              }}
                              alt=""
                            />
                          </div>
                          <p className="font-poppins text-[#46BCED]">
                            {data?.pickup_from_customer_info?.email}
                          </p>
                        </p>
                      </Col>
                    )}

                    {data?.pickup_from_store_before_service_info && (
                      <Col xs={24} lg={6}>
                        <p>
                          <p>{t("Store to Laundry")}</p>
                          <img src={allStore} />
                          <div className="flex items-center justify-between">
                            <p className="font-poppins text-[#46BCED]">
                              {/* John Doe */}
                              {data?.pickup_from_store_before_service_info
                                ?.first_name +
                                " " +
                                data?.pickup_from_store_before_service_info
                                  ?.last_name}
                            </p>
                            <img
                              src={phone}
                              className="h-6"
                              onClick={() => {
                                setPhoneNumber(
                                  data?.pickup_from_store_before_service_info
                                    ?.phone_no
                                );
                                setIsModalVisible(true);
                              }}
                            />
                          </div>
                        </p>
                      </Col>
                    )}

                    {data?.pickup_from_store_after_service_info && (
                      <Col xs={24} lg={6}>
                        <p>
                          <p>{t("Laundry to Store")}</p>
                          <img src={allStore} />
                          <div className="flex items-center justify-between">
                            <p className="font-poppins text-[#46BCED]">
                              {/* John Doe */}
                              {data?.pickup_from_store_after_service_info
                                ?.first_name +
                                " " +
                                data?.pickup_from_store_after_service_info
                                  ?.last_name}
                            </p>
                            <img
                              src={phone}
                              className="h-6"
                              onClick={() => {
                                setPhoneNumber(
                                  data?.pickup_from_store_after_service_info
                                    ?.phone_no
                                );
                                setIsModalVisible(true);
                              }}
                            />
                          </div>
                        </p>
                      </Col>
                    )}

                    {data?.pickup_from_store_after_service_info?.first_name && (
                      <Col xs={24} lg={6}>
                        <p>
                          <p>{t("Store to Customer")}</p>
                          <img src={allStore} />
                          <div className="flex items-center justify-between">
                            <p className="font-poppins text-[#46BCED]">
                              {/* John Doe */}
                              {data?.pickup_from_store_after_service_info
                                ?.first_name +
                                " " +
                                data?.pickup_from_store_after_service_info
                                  ?.last_name}
                            </p>
                            <img
                              src={phone}
                              className="h-6"
                              onClick={() => {
                                setPhoneNumber(
                                  data?.pickup_from_store_after_service_info
                                    ?.phone_no
                                );
                                setIsModalVisible(true);
                              }}
                            />
                          </div>
                        </p>
                      </Col>
                    )}
                  </Row>
                </Card>
              </div>
            )}
          </Col>

          <Col xs={24} lg={16}>
            <div className="">
              {loading ? (
                <>
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                </>
              ) : (
                <Card
                  // title="Order Summary"
                  className="new-ss"
                  title={
                    <div className="flex items-center gap-2">
                      {t("Order Summary")}
                      {orderNote && (
                        <PiNotepad
                          style={{
                            fontSize: "18px",
                            color: "#1890ff",
                            cursor: "pointer",
                            paddingTop: "2px",
                          }}
                          onClick={() => {
                            setIsModalVisibleOrderNote(true);
                          }}
                        />
                      )}
                    </div>
                  }
                >
                  <Row gutter={[16, 16]}>
                    {data?.items_grouped_by_services?.length > 0 ? (
                      data?.items_grouped_by_services?.map((item, index) => {
                        console.log(item, "itemssss");
                        // Determine if at least one item has a note
                        const hasNotes = item?.items?.some(
                          (record) => record?.handle_note
                        );
                        // const hasImages = item?.items?.some(
                        //   (record) => record?.images
                        // );
                        const hasImages = item?.items?.some(
                          (record) => record?.repairing?.is_need_repair
                        );
                        // Define columns
                        const columns = [
                          {
                            title: t("Item"),
                            dataIndex: ["item_info", "item_name"],
                            key: "item_info.item_name",
                            render: (text, record) => (
                              <span>{record?.item_name}</span>
                            ),
                          },
                          {
                            title: t("Quantity"),
                            dataIndex: "item_info.total_quantity",
                            key: "item_info.total_quantity",
                            render: (text, record) => (
                              <span>{record?.quantity + " " + "Items"}</span>
                            ),
                          },
                          {
                            title: t("Price"),
                            dataIndex: "price",
                            key: "price",
                            render: (text, record) => (
                              <span>
                                {record?.price * record?.quantity + " " + "SAR"}
                              </span>
                            ),
                          },
                        ];

                        // Add the "Note" column if notes exist
                        if (hasNotes) {
                          columns.push({
                            title: t("Note"),
                            key: "note",
                            render: (text, record) =>
                              record?.handle_note ? (
                                <PiNotepad
                                  style={{
                                    fontSize: "18px",
                                    color: "#1890ff",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setItemNoteVisible(true);
                                    setItemNote(record?.handle_note);
                                  }}
                                />
                              ) : null,
                          });
                        }

                        // Add the "Images" column if images exist
                        if (hasImages) {
                          columns.push({
                            title: t("Repairing"),
                            key: "images",
                            render: (text, record) => (
                              <span>
                                {record?.repairing?.images?.length > 0 && (
                                  <Badge
                                    count={record?.repairing?.images?.length}
                                    offset={[8, -8]}
                                    style={{
                                      position: "absolute",
                                      right: 0,
                                      backgroundColor: "#46bced",
                                    }}
                                  >
                                    <img
                                      src={
                                        CONSTANTS?.IMG_DIRECTORY +
                                        record?.repairing?.images?.[0]?.file_url
                                      } // Display the first image as an icon or thumbnail
                                      alt="Item Image"
                                      style={{
                                        width: "40px",
                                        cursor: "pointer",
                                        height: "4rem",
                                        borderRadius: "0.5rem",
                                        objectFit: "cover",
                                      }}
                                      onClick={() => {
                                        setImageModalVisible(true);
                                        setSelectedImages(
                                          record?.repairing?.images
                                        );
                                      }}
                                    />
                                  </Badge>
                                )}
                              </span>
                            ),
                          });
                          // columns.push({
                          //   title: "Repairing",
                          //   key: "repairing",
                          //   render: (text, record) =>
                          //     record?.repairing?.is_need_repair ? (
                          //       <img
                          //         src={
                          //           CONSTANTS?.IMG_DIRECTORY +
                          //           record?.repairing?.images?.[0]?.file_url
                          //         } // Display the first image as an icon or thumbnail
                          //         alt="Item Image"
                          //         style={{ width: "40px", cursor: "pointer" }}
                          //         onClick={() => {
                          //           setImageModalVisible(true);
                          //           setSelectedImages(
                          //             record?.repairing?.images
                          //           );
                          //         }}
                          //       />
                          //     ) : null,
                          // });
                        }

                        return (
                          <Col xs={24} lg={12} key={item?._id}>
                            <Collapse
                              defaultActiveKey={["1"]} // Set the default active key
                              style={{ border: "none" }}
                              expandIconPosition="right" // Set the expand icon position to right
                              className="custom-collapsess" // Add a custom class for further styling
                            >
                              <Panel
                                header={item?.service_name}
                                key="1"
                                style={{
                                  border: "none",
                                  background: "#3860A4",
                                  color: "white",
                                  borderRadius: "14px",
                                }}
                              >
                                <Card
                                  type="inner"
                                  className="summary-table"
                                  style={{ border: "none" }}
                                >
                                  <Table
                                    dataSource={item?.items}
                                    // columns={[
                                    //   {
                                    //     title: "Item",
                                    //     dataIndex: ["item_info", "item_name"],
                                    //     key: "item_info.item_name",
                                    //     render: (text, record) => (
                                    //       <span>{record?.item_name}</span>
                                    //     ),
                                    //   },
                                    //   {
                                    //     title: "Quantity",
                                    //     dataIndex: "item_info.total_quantity",
                                    //     key: "item_info.total_quantity",
                                    //     render: (text, record) => (
                                    //       <span>
                                    //         {record?.quantity + " " + "Items"}
                                    //       </span>
                                    //     ),
                                    //   },
                                    //   {
                                    //     title: "Price",
                                    //     dataIndex: "price",
                                    //     key: "price",
                                    //     render: (text, record) => (
                                    //       <span>
                                    //         {record?.price * record?.quantity +
                                    //           " " +
                                    //           "SAR"}
                                    //       </span>
                                    //     ),
                                    //   },
                                    // ]}
                                    // onRow={(record) => ({
                                    //   onClick: () => showModal(record),
                                    // })}
                                    columns={columns}
                                    pagination={false}
                                    style={{
                                      border: "none",
                                      padding: "0",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Card>
                              </Panel>
                            </Collapse>
                          </Col>
                        );
                      })
                    ) : (
                      <button
                        className="btn-gradient  mx-auto flex w-36 items-center justify-center rounded-[1rem] p-4 text-[white]"
                        onClick={() => {
                          // setSelectedStore(record);
                          // setEditModalVisible(true);
                          navigate(`/admin/order-management/edit/${id}?basket=true`);
                        }}
                      >
                        {t("Add Basket")}
                      </button>
                    )}
                  </Row>
                </Card>
              )}
              <div className="current-status">
                <Card>
                  <div className="mb-4">
                    <hr className="mb-4" />

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Service Category")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {data?.order_type}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Total Items")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {data?.invoice_details?.total_items} {t("Items")}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Service Charges")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(
                          data?.invoice_details?.sub_total_amount
                        ).toFixed(2)}{" "}
                        {t("SAR")}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Tax")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.tax).toFixed(2) ?? 0} {t("SAR")}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Delivery Fees")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.delivery_fee).toFixed(
                          2
                        ) ?? 0}{" "}
                        {t("SAR")}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Discount")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#3860A4]">
                        {Number(data?.invoice_details?.discount).toFixed(2) ??
                          0}{" "}
                        {t("SAR")}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Total")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#FF0000]">
                        <Tag
                          color={
                            data?.invoice_details?.payment_status == "unpaid"
                              ? "red"
                              : "green"
                          }
                        >
                          {data?.invoice_details?.payment_status}
                        </Tag>{" "}
                        {Number(data?.invoice_details?.total_amount).toFixed(
                          2
                        ) ?? 0}{" "}
                        {t("SAR")}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Paid Amount")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[green]">
                        {Number(data?.invoice_details?.amount_paid).toFixed(
                          2
                        ) ?? 0}{" "}
                        {t("SAR")}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="font-poppins text-[12px] font-normal text-[#9496AE]">
                        {t("Pending Amount")}
                      </span>
                      <span className="font-poppins text-[15px] font-semibold text-[#800075]">
                        {Number(data?.invoice_details?.amount_due).toFixed(2) ??
                          0}{" "}
                        {t("SAR")}
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </Col>
        </Row>

        {selectedRow && (
          <Modal
            visible={isModalVisibleItems}
            onCancel={handleCancel}
            closeIcon={false}
            style={{ minWidth: "674px" }}
            className="item-modal"
          >
            <div className="flex flex-row items-center justify-between px-[26px] pb-[9px]">
              <h1 className="text-[20px] font-medium leading-[28px] text-[#3860A4]">
                {selectedRow?.item_info?.item_name}
              </h1>
              <h1 className="text-[20px] font-medium leading-[28px] text-[#3860A4]">
                {t("Wash + Iron")}
              </h1>
            </div>
            <div className="item-modal border-y-[1px] px-[26px] py-[18px]">
              <Col>
                <div className="flex flex-row items-start justify-between">
                  <Card className="side-card w-[299px] cursor-pointer rounded-lg border px-[14px] py-[14px] shadow-lg">
                    <div className="flex items-center justify-between pr-2">
                      <div className="flex flex-row items-center gap-[12px]">
                        <img
                          src={
                            displayImage
                              ? displayImage
                              : selectedRow?.item?.images?.[0]?.file_url
                              ? CONSTANTS?.IMG_DIRECTORY +
                                selectedRow?.item?.images?.[0]?.file_url
                              : fallBackImage
                          }
                          alt="Item"
                          className="h-14 w-14 rounded-2xl"
                        />

                        <div className="flex flex-col gap-[15px] ">
                          <p className="text-[#46BCED]">
                            {selectedRow?.item_info?.item_name}
                          </p>
                          <div className="flex h-[28px] w-[73px] flex-row items-center justify-between rounded-[100px] bg-[#172e5512]  px-[6px]">
                            <div
                              onClick={() => handleCountMinus(selectedRow)}
                              className="flex h-[16px] w-[16px] flex-row content-center items-center justify-center rounded-full border-[1px] border-[#9496AE80] text-[#9496AE80]"
                            >
                              -
                            </div>
                            <p className="text-600 text-[#3860A4]">
                              {itemCounts[selectedRow?._id] || 1}
                            </p>{" "}
                            <div
                              onClick={() => {
                                handleCountPlus(selectedRow);
                              }}
                              className="flex h-[16px] w-[16px] items-center justify-center rounded-full bg-[#46BCED] text-center text-white"
                            >
                              +
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h3 className=" font-poppins text-[15px] font-normal text-[#3860A4]">
                          {selectedRow?.tem_info?.item_name}
                        </h3>
                      </div>
                      <div>
                        <span className="font-poppins font-semibold text-[#3860A4]">
                          {t("SAR")}{calculateTotalPrice(selectedRow)}
                        </span>
                      </div>
                    </div>
                    <div className="mt-[20px] flex flex-row items-center justify-between">
                      <div className="flex flex-row items-start ">
                        <div onClick={() => setImageModal(true)}>
                          <img src={cameraIcon} alt="" />
                        </div>
                        {imagesToSend?.length > 0 ? (
                          <div className="scroll-behaviour flex w-[145px] flex-row items-center space-x-1 overflow-scroll overflow-y-hidden">
                            {imagesToSend?.map((element, idx) => {
                              return (
                                <div
                                  key={idx}
                                  className="h-[25px] w-[25px]"
                                  onClick={() =>
                                    setDisplayImage(
                                      CONSTANTS?.IMG_DIRECTORY +
                                        element?.file_url
                                    )
                                  }
                                >
                                  <img
                                    src={
                                      CONSTANTS?.IMG_DIRECTORY +
                                      element?.file_url
                                    }
                                    alt=""
                                  />
                                </div>
                              );
                            })}
                          </div>
                        ) : null}
                      </div>

                      <div>
                        {" "}
                        <Checkbox className="text-gray-400 ">
                          {t("Repairing")}
                        </Checkbox>
                      </div>
                    </div>
                  </Card>
                </div>
              </Col>
            </div>
            <div className="flex h-full  flex-row items-center justify-center pb-[23px] pt-[17px] ">
              <button className="h-[43px] w-[204px] rounded-[9.6px] bg-[#7E80FE] text-center text-white">
                {t("Confirm")}
              </button>
            </div>

            <Modal
              visible={imageModal}
              onCancel={() => setImageModal(false)}
              closeIcon={false}
              className="image-upload"
            >
              {image ? (
                <div className="flex flex-col items-center justify-between gap-[21px]">
                  <div className="flex h-[208px] w-[426px]  items-center justify-center overflow-hidden">
                    <img src={image} alt="" />{" "}
                  </div>
                  <div className="flex flex-row items-center gap-[18.36px]">
                    <button
                      onClick={() => {
                        if (image) {
                          setImage(null);
                          setTriggerUpload(true);
                        }
                      }}
                      className="flex h-[48.14px] w-[162px] items-center justify-center rounded-[3.78px] text-center text-[#3860A4] shadow-xl"
                    >
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleImageUpload}
                      />
                      {t("Redo")}
                    </button>
                    <button
                      className="flex h-[48.14px] w-[162px] items-center justify-center rounded-[3.78px] bg-[#7E80FE] text-center text-white shadow-xl"
                      onClick={() => handleUploadImage(imageToUpload)}
                    >
                      {t("OK")}
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  onClick={() => {
                    setImageModal(true);
                    handleImageClick();
                  }}
                  className="flex flex-col items-center justify-center"
                >
                  <img src={uploadCameraImage} alt="" />
                  <h1 className="text-[17.88px] font-normal text-[#3860A4]">
                    {t("Upload Image")}{" "}
                  </h1>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleImageUpload}
                  />
                </div>
              )}
            </Modal>
          </Modal>
        )}
      </Content>
      <Modal
        title="Select Driver"
        className="order-driver-modal driver-mod"
        visible={isModalVisibleDriver}
        onCancel={() => setIsModalVisibleDriver(false)}
        footer={null}
        centered
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Table
              columns={columns}
              dataSource={drivers}
              rowKey="email"
              style={{ width: "100%" }}
              rowClassName={rowClassName}
              rowStyle={rowStyles}

              // pagination={{ pageSize: 5 }}
            />
          </Col>
          <Col span={12}>
            <div style={{ height: "400px" }}>
              <DriverMap
                drivers={driversNew}
                onDriverSelect={handleDriverSelect}
                radius={radius}
                orderData={data}
              />
            </div>
            <Slider
              min={500}
              max={5000}
              step={100}
              value={radius}
              onChange={(value) => setRadius(value)}
              // tooltipVisible
            />
          </Col>
        </Row>
      </Modal>
      <Modal
        title="Change Order Status"
        visible={isModalVisibleStatus}
        // onOk={handleOk}
        onCancel={() => setIsModalVisibleStatus(false)}
      >
        <div className="relative">
          <label
            for="floating_outlined"
            className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-[17px] text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
            style={{ fontSize: "17px" }}
          >
            {t("Select Store")}
          </label>
          <Select
            className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
            // {...field}
            // value={store}
            showSearch
            placeholder={t("Select Store")}
            optionFilterProp="children"
            onPopupScroll={handleScrollStore}
            filterOption={(input, option) =>
              option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            loading={loadingStore}
            onChange={(value) => {
              console.log("value", value);
              setStore(value);
              // StatusApiCall(value);
              // setFieldValue("laundry", value);
              // setTouched({ laundry: true });
            }}
          >
            {dataStore?.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.store_name}
              </Option>
            ))}
          </Select>
          <div className="flex gap-4">
            <Button
              className="btn-gradient  ml-2 mt-5 flex w-36 items-center justify-center p-5 text-[white]"
              onClick={() => {
                StatusApiCall(status);
                console.log("clickeddd...");
              }}
            >
              {t("confirm")}
            </Button>
            <Button
              className="btn-gradient  ml-2 mt-5 flex w-36 items-center justify-center p-5 text-[white]"
              onClick={() => {
                setIsModalVisibleStatus(false);
              }}
            >
              {t("Cancel")}
            </Button>
          </div>
        </div>
      </Modal>
      <div style={{ display: "none" }}>
        <div
          className="flex flex-col items-center justify-center rounded-lg bg-white p-4 shadow-md "
          ref={componentRef}
        >
          <Printinvoice data={data} />
        </div>
      </div>

      {/* order notesss */}

      <Modal
        title=" order note"
        visible={isModalVisibleOrderNote}
        // onOk={handleOk}
        onCancel={() => setIsModalVisibleOrderNote(false)}
        centered
      >
        <p>{orderNote ? orderNote : "No Order Note provided"}</p>
      </Modal>
      {/* Item notesss */}

      <Modal
        title={t("Item note")}
        visible={itemNoteVisible}
        // onOk={handleOk}
        onCancel={() => setItemNoteVisible(false)}
        centered
      >
        <p>{itemNote ? itemNote : t("No Item Note provided")}</p>
      </Modal>

      <Modal
        visible={imageModalVisible}
        footer={null}
        onCancel={() => setImageModalVisible(false)}
        title={t("Repairing Images")}
      >
        <Carousel>
          {selectedImages?.map((image, index) => (
            <div key={index}>
              <img
                src={
                  image?.file_url
                    ? CONSTANTS?.IMG_DIRECTORY + image?.file_url
                    : "https://via.placeholder.com/400x400?text=No+Image"
                }
                alt={`Repairing image ${index}`}
                style={{ width: "100%", height: "400px", objectFit: "cover" }}
              />
            </div>
          ))}
        </Carousel>
      </Modal>
    </Layout>
  );
};

export default ViewUpdated;
